import { defineComponent as l, openBlock as n, createBlock as o, unref as r, mergeProps as d, withCtx as m, createElementVNode as e } from "vue";
import { RevIcon as p } from "@ds/components/Icon";
const u = /* @__PURE__ */ l({
  name: "IconReassuranceSmileyFilled",
  __name: "IconReassuranceSmileyFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const c = t;
    return (s, a) => (n(), o(r(p), d(c, { "view-box": "0 0 48 48" }), {
      default: m(() => [...a[0] || (a[0] = [
        e("g", { "clip-path": "url(#e39dfab5-3d3e-401f-8980-b56c49f1c97da)" }, [
          e("path", { d: "M24 0a24 24 0 1 0 0 48 24 24 0 0 0 0-48m16 28.69a.5.5 0 1 1-.9-.42c.15-.33 3.72-8.13-1-14.9C34.38 8 28.18 7.3 25.69 7.26a18.13 18.13 0 0 0-11.61 4.2A17.24 17.24 0 0 0 7.75 22c-1.18 7.29 1.93 13.81 8.11 17A15.4 15.4 0 0 0 23 40.74a17 17 0 0 0 11.46-4.66l-3-.47A.5.5 0 0 1 31.1 35a.51.51 0 0 1 .57-.42l4 .63a.5.5 0 0 1 .41.57l-.62 4a.51.51 0 0 1-.5.43h-.07a.5.5 0 0 1-.42-.57L34.91 37A17.94 17.94 0 0 1 23 41.74a16.4 16.4 0 0 1-7.63-1.87c-6.55-3.42-9.86-10.34-8.61-18.06a18.18 18.18 0 0 1 6.69-11.12 19 19 0 0 1 12.26-4.43c2.64 0 9.22.77 13.21 6.55 5 7.19 1.21 15.53 1.08 15.88m-20.42 1.49A8.7 8.7 0 0 0 24 31.36a11.84 11.84 0 0 0 7.77-3.09 10.85 10.85 0 0 0 2.86-4.39.5.5 0 0 1 .94.34A11.8 11.8 0 0 1 32.48 29 12.86 12.86 0 0 1 24 32.36a9.7 9.7 0 0 1-5-1.31 11 11 0 0 1-5-7.35L12.69 26a.5.5 0 0 1-.43.24A.5.5 0 0 1 12 26.2a.5.5 0 0 1-.17-.69L14 22a.52.52 0 0 1 .31-.23.5.5 0 0 1 .37.06L18.12 24a.5.5 0 0 1-.52.85L15 23.28a10 10 0 0 0 4.58 6.9m2-10.47c.58-1.62 1.6-2.74 2.28-2.5s.76 1.75.18 3.38-1.6 2.74-2.28 2.5-.76-1.76-.22-3.38h.04m6.23-.18c.58-1.62 1.6-2.74 2.27-2.5s.76 1.76.18 3.38-1.6 2.74-2.28 2.5-.79-1.75-.21-3.38h.04" })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "e39dfab5-3d3e-401f-8980-b56c49f1c97da" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
